export default __webpack_public_path__ + "static/media/ic-spire.a6f6d737.svg";